<script setup lang="ts">
import { computed } from 'vue';
import { RouterView } from 'vue-router';

import UErrorView from '@/shared/components/UErrorView.vue';
import { useError } from '@/shared/composables/useError';

const { error } = useError();
const hasError = computed(() => Boolean(error.value?.statusCode));
</script>

<template>
  <!-- Chrome-free: the login and magic-link screens, and the built-in error
       pages. -->
  <div class="relative min-h-svh">
    <UErrorView v-if="hasError" />
    <RouterView v-else />
  </div>
</template>
